<div class="not-md:font-semibold">
  @if (range(); as range) {
    @if (range.min) {
      <span class="fade-slide-in">{{ range.min | currency }}</span>
    }

    @if (range.max; as maxPrice) {
      <span class="fade-slide-in"> - {{ maxPrice | currency }}</span>
    }

    @if(item().fet; as fet) {
      <div class="text-2xs">
        <span>F.E.T. {{fet | currency}}</span>
      </div>
    }
  } @else if (hasCost() && resultsStore.isPricingPending() && !range()?.hasPulled) {
    <span class="flex justify-end">
      <app-spinner size="sm"></app-spinner>
    </span>
  } @else {
    <span class="md:hidden">N/A</span>
  }
</div>
